$(document).ready(function () {
	let tmSearch;
	let $form = $('form.vg-search');
	let hSearchContent = $form.find('.vg-search-content');

	$('.search-input').on('keyup change', function () {
		$('.search-input').not(this).val($(this).val());

		let $self = $(this),
			$self_form = $self.closest('form'),
			target = $self_form.data('target'),
			tabID = $self_form.data('tab-id') || 1,
			$content = $(target),
			search = $self.val();

		clearTimeout(tmSearch);

		if (search) {
			tmSearch = setTimeout(() => {
				$content.addClass('focused');

				$.get('/s/lookup', {search: search}, function (data) {
					if (data.view) {
						$('.vg-search').find('.vg-search-content-body').html(data.view);
						$content.addClass('focused');

						let $panes = $content.find('.tab-pane');
						$panes.each(function () {
							let id = $(this).attr('id');
							$(this).attr('id', id + tabID)
						});

						let $links = $content.find('.nav-link');
						$links.each(function () {
							let href = $(this).attr('href');
							$(this).attr('href', href + tabID)
						});
					} else {
						$content.removeClass('focused');
					}
				});
			}, 500);
		} else {
			$content.removeClass('focused');
		}
	});

	$(document).mouseup(function (e) {
		if (hSearchContent.has(e.target).length === 0) {
			hSearchContent.removeClass('focused');
		}
	});

	let $searchCity = $('.cities-search');
	if ($searchCity.length) {
		$searchCity.on('input change', function () {
			var val = $(this).val();
			var $countries = $('.countries');

			if (!val) {
				$('.cities-group, .cities-group a').show();
				return;
			}

			$('.cities-group').each(function (i, cityGroup) {
				var cntVisible = 0;

				$(cityGroup).find('a').each(function (i, city) {
					var cityName = $(city).text();
					var visible = cityName.toLowerCase().indexOf(val.toLowerCase()) !== -1;

					if (visible) {
						$(city).show();
						cntVisible++;
					} else {
						$(city).hide();
					}
				});

				if (cntVisible) {
					$(cityGroup).show();
				} else {
					$(cityGroup).hide();
				}
			})
		});
	}
});